import { makeHttpRequest } from "@/shared";

import { mapPointToServer } from "./mappers/mapPointToServer";

export const editPoint = async (id, point) => {
    const response = (
        await makeHttpRequest({
            url: `/point/${id}`,
            method: "PUT",
            data: mapPointToServer(point),
        })
    ).data;

    return response;
};
